<template>
  <tbody>
      <tr v-if="!datas">
          <td colspan="5">加载中......</td>
      </tr>
      <template v-if="datas && datas.length">
          <tr v-for="(data, index) in datas" :key="index" :class="{important: data.star > 2}">
              <td class="ushk-rili_content-time">{{ data.public_time }}</td>
              <td>
                {{ data.country }}
              </td>
              <td>{{ data.city }}</td>
              <td>
                <star :width="data.star"/>
              </td>
              <td>
                  <div class="l-cell">
                      <p v-if="data.people" class="l-cell_item ushk-rili_content-img"><img :src="`//cdn.jin10.com/images/flag/tx/${data.people}.png`"></p>
                      <p class="l-cell_item">
                          {{ data.eventcontent }}
                          <span v-if="typeof data.relates !== 'undefined' && (data.relates.news || data.relates.video || data.relates.flash)" style="display: block;">【 扩展阅读：
                            <a v-if="data.relates.news" :href="`//news.jin10.com/rili_event.html?cate=${data.id}`" target="_blank">新闻 </a>
                            <a v-if="data.relates.video" href="`//v.jin10.com/rili_event.html?cate=${data.id}`" target="_blank">视频 </a>
                            <a v-if="data.relates.flash" href="`//www.jin10.com/rili_event.html?cate=${data.id}`" target="_blank">快讯 </a>】
                          </span>
                      </p>
                  </div>
              </td>
          </tr>
      </template>
      <tr v-else>
          <td colspan="5">今日无财经大事</td>
      </tr>
  </tbody>
</template>
<script>
    export default {
      props: {
        datas: {
          type: [Array, Boolean],
          default: false
        }
      },
      data () {
        return {
        }
      }
    }
  </script>


// WEBPACK FOOTER //
// EventsList.vue?170cd0a4